<template>
  <v-toolbar
    dark
    tabs
    fixed
    app
    :flat="true"
    :color="eventEndDate ? 'grey darken-3' : 'primary'"
    id="main-toolbar"
  >

    <!-- Bar for country page -->
    <template v-if="['Countries', 'CountryGeneralDetails', 'CountryMap'].indexOf($route.name) !== -1">
      <v-btn
        icon
        @click="backButtonHandler(false)"
        class="hidden-md-and-down"
      >
        <v-icon>arrow_forward</v-icon>
      </v-btn>
      <v-btn
        icon
        @click="backButtonHandler(true)"
        class="hidden-lg-and-up"
      >
        <v-icon>arrow_forward</v-icon>
      </v-btn>
      <v-toolbar-side-icon
        @click.stop="mainMenuMiniVariant = !mainMenuMiniVariant"
        class="hidden-md-and-down"
      ></v-toolbar-side-icon>
      <v-toolbar-side-icon
        @click.stop="toggleMenuForMobile"
        class="hidden-lg-and-up"
      ></v-toolbar-side-icon>
      <v-toolbar-title class="ml-3">תיקי מדינה</v-toolbar-title>
      <v-autocomplete
        :loading="loading"
        :items="activeCountries"
        v-model="selectedCountry"
        cache-items
        hide-no-data
        hide-details
        :item-text="'name'"
        :item-value="'_id'"
        label="בחירת מדינה"
        solo-inverted
        clearable
        flat
        @change="onCountryChange"
      ></v-autocomplete>
      <v-spacer></v-spacer>

      <v-tabs
        v-if="$route.params.id"
        slot="extension"
        align-with-title
        color="transparent"
      >
        <v-tab
          v-for="tab in countryTabs"
          :key="tab.path"
          :to="tab.path"
          replace
          exact
        >{{ tab.title }}</v-tab>
        <v-tabs-slider color="secondary"></v-tabs-slider>
      </v-tabs>
      <!-- <v-spacer></v-spacer> -->
    </template>

    <!-- Bar for Partner page -->
    <template v-else-if="['PartnerGeneralDetails', 'PartnerContacts', 'PartnerFiles', 'PartnerMap'].indexOf($route.name) !== -1">
      <v-btn
        icon
        @click="backButtonHandler(false)"
        class="hidden-md-and-down"
      >
        <v-icon>arrow_forward</v-icon>
      </v-btn>
      <v-btn
        icon
        @click="backButtonHandler(true)"
        class="hidden-lg-and-up"
      >
        <v-icon>arrow_forward</v-icon>
      </v-btn>
      <v-toolbar-side-icon
        @click.stop="mainMenuMiniVariant = !mainMenuMiniVariant"
        class="hidden-md-and-down"
      ></v-toolbar-side-icon>
      <v-toolbar-side-icon
        @click.stop="toggleMenuForMobile"
        class="hidden-lg-and-up"
      ></v-toolbar-side-icon>
      <v-toolbar-title>{{ partnerMainName }}</v-toolbar-title>
      <v-spacer></v-spacer>
      <v-btn
        flat
        icon
        large
        @click="editPartner(partner, false)"
        v-if="shouldShow(['ADMIN', 'RESEARCHER'], user)"
      >
        <v-icon>edit</v-icon>
      </v-btn>
      <v-btn
        flat
        icon
        large
        @click="removePartner"
        v-if="shouldShow(['ADMIN', 'RESEARCHER'], user)"
      >
        <v-icon>delete</v-icon>
      </v-btn>
      <v-tabs
        slot="extension"
        align-with-title
        color="transparent"
      >
        <v-tab
          v-for="tab in partnerTabs"
          :key="tab.path"
          :to="tab.path"
          :replace="true"
          exact
        >{{ tab.title }}</v-tab>
        <v-tabs-slider color="secondary"></v-tabs-slider>
      </v-tabs>
    </template>

    <!-- Bar for Translator page -->
    <template v-else-if="['TranslatorGeneralDetails'].indexOf($route.name) !== -1">
      <v-btn
        icon
        @click="backButtonHandler(false)"
        class="hidden-md-and-down"
      >
        <v-icon>arrow_forward</v-icon>
      </v-btn>
      <v-btn
        icon
        @click="backButtonHandler(true)"
        class="hidden-lg-and-up"
      >
        <v-icon>arrow_forward</v-icon>
      </v-btn>
      <v-toolbar-side-icon
        @click.stop="mainMenuMiniVariant = !mainMenuMiniVariant"
        class="hidden-md-and-down"
      ></v-toolbar-side-icon>
      <v-toolbar-side-icon
        @click.stop="toggleMenuForMobile"
        class="hidden-lg-and-up"
      ></v-toolbar-side-icon>
      <v-toolbar-title>{{ translatorMainName }}</v-toolbar-title>
      <v-spacer></v-spacer>
      <v-btn
        flat
        icon
        large
        @click="editTranslator(translator, false)"
        v-if="shouldShow(['ADMIN', 'RESEARCHER'], user)"
      >
        <v-icon>edit</v-icon>
      </v-btn>
      <v-btn
        flat
        icon
        large
        @click="removeTranslator"
        v-if="shouldShow(['ADMIN', 'RESEARCHER'], user)"
      >
        <v-icon>delete</v-icon>
      </v-btn>
      <v-tabs
        slot="extension"
        align-with-title
        color="transparent"
      >
        <v-tab
          v-for="tab in translatorTabs"
          :key="tab.path"
          :to="tab.path"
          :replace="true"
          exact
        >{{ tab.title }}</v-tab>
        <v-tabs-slider color="secondary"></v-tabs-slider>
      </v-tabs>
    </template>

    <!-- Bar for Event page -->
    <template v-else-if="$route.name === 'Event'">
      <v-btn
        icon
        @click="backButtonHandler"
        class="hidden-md-and-down"
      >
        <v-icon>arrow_forward</v-icon>
      </v-btn>
      <v-btn
        icon
        @click="backButtonHandler(true)"
        class="hidden-lg-and-up"
      >
        <v-icon>arrow_forward</v-icon>
      </v-btn>
      <v-toolbar-title>
        <span v-if="showAllEvents && currentEventAran">אר"ן ({{ currentEventAran.name }})</span>
        <span v-else>
          {{ event ? event.title : 'ללא כותרת' }}
          <span v-if="currentEventAran" class="caption">({{ currentEventAran.name }})</span>
        </span>
      </v-toolbar-title>
      <v-spacer></v-spacer>

      <!-- <v-btn
        v-for="(item, index) in eventPageButtons"
        :key="'eventPageButton' + index"
        color="white"
        flat
        icon
        v-on="on"
        @click="envokeMethodByName(item.click)"
      >
        <v-icon>{{ item.icon }}</v-icon>
      </v-btn> -->

      <v-spacer></v-spacer>
      <world-clock />
      <v-chip
        color="white"
        class="hidden-sm-and-down"
        text-color="grey darken-3"
        v-if="eventManager"
      >
        <v-avatar>
          <img
            :src="eventManager.image ? eventManager.image : userAvatar(eventManager)"
          >
        </v-avatar>
        {{ eventManager.name }}
      </v-chip>
      <v-chip
        color="white"
        class="hidden-sm-and-down"
        text-color="grey darken-3"
        v-if="eventEndDate"
      >הסתיים ב- {{ eventEndDate }}</v-chip>
      <v-chip
        color="secondary"
        class="hidden-sm-and-down"
        text-color="white"
        v-else
      >אירוע פעיל</v-chip>

      <!-- Excel/Google Sheets Link -->
      <v-btn
        v-if="event && event.spreadsheetUrl"
        icon
        dark
        :href="event.spreadsheetUrl"
        target="_blank"
        rel="noopener noreferrer"
        class="ml-2"
      >
        <v-icon>mdi-file-excel</v-icon>
      </v-btn>

  

      <!-- ARAN Events Dropdown -->
      <v-menu
        v-if="currentEventAran && aranEvents.length >= 1"
        offset-y
        left
        content-class="aran-events-menu"
      >

     
        <v-btn
          slot="activator"
          color="white"
          flat
          small
        >
          <v-icon left>account_tree</v-icon>
          אירועי א"רן ({{ aranEvents.length }})
        </v-btn>
        <v-list dense>
          <v-list-tile
            v-for="event in aranEvents"
            :key="event._id"
            @click="navigateToEvent(event._id)"
            :class="{ 'primary--text': event._id === $route.params.id }"
          >
            <v-list-tile-title>
              {{ event.title || `אירוע ${event._id}` }}
              <span v-if="event._id === $route.params.id" class="caption">(נוכחי)</span>
              <span class="caption ml-1" :class="{ 'green--text': !event.endDate, 'grey--text': event.endDate }">
                ({{ getEventStatus(event) }})
              </span>
            </v-list-tile-title>
          </v-list-tile>
          <v-divider></v-divider>
          <v-list-tile @click="toggleAllEvents">
            <v-list-tile-title class="font-weight-bold">
              <v-icon left small>{{ showAllEvents ? 'event' : 'list' }}</v-icon>
              {{ getCyclingButtonText() }}
            </v-list-tile-title>
          </v-list-tile>
        </v-list>
      </v-menu>

   
   

      <v-menu offset-y>
        <v-btn
          slot="activator"
          color="white"
          flat
        >
          תצוגה {{ eventPageLayout }}
        </v-btn>
        <v-list>
          <v-list-tile
            v-for="(item, index) in eventPageLayouts"
            :key="index"
            @click="setLayout(item)"
          >
            <v-list-tile-title>{{ item }}</v-list-tile-title>
          </v-list-tile>
        </v-list>
      </v-menu>
      <v-menu
        bottom
        left
      >
        <v-btn
          slot="activator"
          dark
          icon
        >
          <v-icon>more_vert</v-icon>
        </v-btn>

        <v-list>
          <v-list-tile
            v-for="(item, i) in eventPageMenuItems"
            :key="'eventPageMenuItems' + i"
            @click="envokeMethodByName(item.click)"
            v-if="shouldShow(item.roles, user)"
          >
            <v-list-tile-title :class="{ 'red--text': item.color === 'red' }">{{ item.title }}</v-list-tile-title>
          </v-list-tile>
        </v-list>
      </v-menu>
    </template>

    <!-- Bar for other pages -->
    <template v-else>
      <v-btn
        icon
        @click="backButtonHandler(false)"
        class="hidden-md-and-down"
        v-if="$route.path !== '/'"
      >
        <v-icon>arrow_forward</v-icon>
      </v-btn>
      <v-btn
        icon
        @click="backButtonHandler(true)"
        class="hidden-lg-and-up"
      >
        <v-icon>arrow_forward</v-icon>
      </v-btn>
      <v-toolbar-side-icon
        @click.stop="mainMenuMiniVariant = !mainMenuMiniVariant"
        class="hidden-md-and-down"
      ></v-toolbar-side-icon>
      <v-toolbar-side-icon
        @click.stop="toggleMenuForMobile"
        class="hidden-lg-and-up"
      ></v-toolbar-side-icon>
      <v-toolbar-title>{{ title || 'ללא כותרת' }}</v-toolbar-title>
      <v-spacer></v-spacer>
      <v-btn
        v-if="actionButton && shouldShow(actionButton.roles, user)"
        color="secondary"
        large
        @click="envokeMethodByName(actionButton.click)"
      >
        {{ actionButton.title }}
      </v-btn>
      <v-tabs
        v-if="tabs"
        slot="extension"
        align-with-title
        color="transparent"
      >
        <v-tab
          v-for="tab in tabs"
          :key="tab.path"
          :to="tab.path"
          :replace="false"
          exact
        >{{ tab.title }}</v-tab>
        <v-tabs-slider color="secondary"></v-tabs-slider>
      </v-tabs>
    </template>
  </v-toolbar>
</template>

<script>
import generateId from "@/idGenerator";
import shouldShow from "@/utils/shouldShow";
import { format } from "date-fns";
import colors from "vuetify/es5/util/colors";
import WorldClock from "./WorldClock.vue";

export default {
  data: () => ({
    newEventDialog: false,
    loading: false,
    isFirstPage: true,
    barData: [
      {
        routeNames: ["ActiveEvents", "EventsArchive"],
        title: "אירועים",
        tabs: [
          {
            title: "אירועים פעילים",
            path: "/events"
          },
          {
            title: "כל האירועים",
            path: "/events/archive"
          }
        ],
        actionButton: {
          title: "אירוע חדש",
          click: "showAddEventDialog",
          roles: ["ADMIN", "EVENT_MANAGER"]
        }
      },
      {
        routeNames: ["CountryGeneralDetails", "CountryMap"],
        title: "תיקי מדינה"
      },
      {
        routeNames: ["Partners"],
        title: "ספקים",
        actionButton: {
          title: "הוספת ספק",
          click: "createPartner",
          roles: ["ADMIN", "RESEARCHER"]
        }
      },
      {
        routeNames: ["Partner"],
        actionButton: {
          title: "עריכה",
          click: "editPartner",
          roles: ["ADMIN", "RESEARCHER"]
        }
      },
      {
        routeNames: ["Translators"],
        title: "מתורגמנים",
        actionButton: {
          title: "הוספת מתורגמן",
          click: "createTranslator",
          roles: ["ADMIN", "RESEARCHER"]
        }
      },
      {
        routeNames: ["Translator"],
        actionButton: {
          title: "עריכה",
          click: "editTranslator",
          roles: ["ADMIN", "RESEARCHER"]
        }
      },
      {
        routeNames: ["Dashboard", "DashboardInfo"],
        title: "לוח בקרה",
        tabs: [
          {
            title: "מידע כללי",
            path: "/info"
          },
          {
            title: "לוח בקרה",
            path: "/"
          }
        ],
        actionButton: {
          title: "אירוע חדש",
          click: "showAddEventDialog",
          roles: ["ADMIN", "EVENT_MANAGER"]
        }
      },
      {
        routeNames: ["Reports", "DutiesReports", "ActivityLogs", "StandardsReports"],
        title: "דו״חות",
        tabs: [
          // {
          //   title: "כללי",
          //   path: "/reports"
          // },
          {
            title: "בעלי תפקידים",
            path: "/reports/duties"
          },
          {
            title: "עמידה בתקן",
            path: "/reports/standards"
          },
          {
            title: "לוג פעולות",
            path: "/reports/activity-logs"
          }
        ]
      },
      {
        routeNames: ["Map"],
        title: "מפה"
      },
      {
        routeNames: ["SystemSetup", "Users", "Standards"],
        title: "הגדרות מערכת",
        tabs: [
          {
            title: "כללי",
            path: "/system-setup"
          },
          {
            title: "משתמשים",
            path: "/system-setup/users"
          },
          {
            title: "תקנים",
            path: "/system-setup/standards"
          }
          // {
          //   title: "אנשי קשר",
          //   path: "/system-setup/contacts"
          // },
          // {
          //   title: "בד״חים",
          //   path: "/system-setup/checklists"
          // },
          // {
          //   title: "שכבות מפה",
          //   path: "/system-setup/map-layers"
          // }
        ]
      }
    ],
    eventPageMenuItems: [
      {
        title: "עריכת פרטי אירוע",
        click: "editEvent",
        roles: ["ADMIN", "EVENT_MANAGER"]
      },
      {
        title: "בעלי תפקידים",
        click: "showEventDutiesDialog",
        roles: ["ADMIN", "EVENT_MANAGER"]
      },
      {
        title: "סיום אירוע",
        click: "showCloseEventDialog",
        roles: ["ADMIN", "EVENT_MANAGER"]
      },
      {
        title: "מחיקת אירוע",
        color: "red",
        click: "removeEvent",
        roles: ["ADMIN"]
      }
    ],
    eventPageButtons: [
      {
        title: "מזג אויר",
        click: "showWeatherForEvent",
        icon: "mdi-weather-cloudy"
      },
      {
        title: "זמני זריחה ושקיעה",
        click: "showSunriseSunsetForEvent",
        icon: "mdi-weather-sunset-up"
      },
      {
        title: "שעון מקומי",
        click: "showLocalTimeForEvent",
        icon: "mdi-clock"
      },
      {
        title: "פרטי אירוע",
        click: "showEventInformation",
        icon: "mdi-information-outline"
      }
    ]
  }),

  computed: {
    entityEditDialog: {
      get() {
        return this.$store.state.entityEditDialog;
      },
      set(payload) {
        this.$store.commit("TOGGLE_ENTITY_EDIT_DIALOG", payload);
      }
    },
    isMainMenuActive: {
      get() {
        return this.$store.getters["isMainMenuActive"];
      },
      set(isActive) {
        this.$store.dispatch("TOGGLE_MAIN_MENU", { isActive });
      }
    },
    mainMenuMiniVariant: {
      get() {
        return this.$store.getters["mainMenuMiniVariant"];
      },
      set(isActive) {
        this.$store.dispatch("SET_MAIN_MENU_MINI_VARIANT", { isActive });
      }
    },
    eventPageLayouts() {
      return this.$store.getters["events/eventPageLayouts"];
    },
    eventPageMenu() {
      return this.$store.getters["events/eventPageMenu"];
    },
    eventPageLayout: {
      get() {
        return this.$store.getters["events/eventPageLayout"];
      },
      set(layout) {
        this.$store.commit("events/SET_EVENT_PAGE_LAYOUT", layout);
      }
    },
    selectedCountry: {
      get() {
        return this.$store.getters["countries/selectedCountry"];
      },
      set(val) {
        this.$store.commit("countries/SET_SELECTED_COUNTRY", val);
      }
    },
    shouldShowMainMenuAutomatically: {
      get() {
        return this.$store.getters["shouldShowMainMenuAutomatically"];
      },
      set(payload) {
        this.$store.dispatch("SET_SHOULD_SHOW_MAIN_MENU_AUTOMATICALLY", {
          payload
        });
      }
    },
    activePageBarData() {
      let activePath = this.$route.path;
      let routeName = this.$route.name;
      let activePageBarData = this.barData.find(item => {
        let paths = item.routeNames;
        let path = paths.find(item2 => {
          return routeName === item2;
        });
        return path ? true : false;
      });
      return activePageBarData;
    },
    title() {
      let activePageBarData = this.activePageBarData;
      if (activePageBarData) {
        return activePageBarData.title;
      }
    },
    tabs() {
      let activePageBarData = this.activePageBarData;
      if (activePageBarData) {
        return activePageBarData.tabs;
      }
    },
    actionButton() {
      let activePageBarData = this.activePageBarData;
      if (activePageBarData) {
        return activePageBarData.actionButton;
      }
    },
    eventId() {
      return this.$route.params.id;
    },
    event() {
      return this.$store.getters["entity"]("events", this.eventId);
    },
    eventEndDate() {
      if (this.event) {
        if (this.event.endDate) {
          return format(new Date(this.event.endDate), "DD/MM/YYYY HH:mm");
        }
      }
    },
    eventManager() {
      let managerId = this.$store.getters["events/eventCurrentManagers"](
        this.eventId
      );
      if (managerId) {
        let user = this.$store.state.entities.users[managerId];
        if (user) {
          return {
            name: user.name,
            image: user.image
          };
        }
      }
      return null;
    },
    partnerId() {
      return this.$route.params.id;
    },
    partner() {
      return this.$store.getters["entity"]("partners", this.partnerId);
    },
    translatorId() {
      return this.$route.params.id;
    },
    translator() {
      return this.$store.getters["entity"]("translators", this.translatorId);
    },
    partnerTabs() {
      return [
        {
          title: "פרטים כללים",
          path: `/partners/${this.$route.params.id}`
        },
        {
          title: "מפה",
          path: `/partners/${this.$route.params.id}/map`
        },
        {
          title: "קבצים",
          path: `/partners/${this.$route.params.id}/files`
        }
      ];
    },
    translatorTabs() {
      return [
        {
          title: "פרטים כללים",
          path: `/translators/${this.$route.params.id}`
        }
      ];
    },
    countryTabs() {
      return [
        {
          title: "כללי",
          path: `/countries/${this.$route.params.id}`
        }
        // {
        //   title: "מפה",
        //   path: `/countries/${this.$route.params.id}/map`
        // }
      ];
    },
    translatorMainName() {
      if (this.translator) {
        return this.translator.name || "ללא שם";
      } else {
        return "טוען...";
      }
    },
    partnerMainName() {
      if (this.partner) {
        if (this.partner.name) {
          return this.partner.name;
        } else if (this.partner.nameEn) {
          return this.partner.nameEn;
        } else {
          return "ללא שם";
        }
      } else {
        return;
      }
    },
    partnerSecondaryName() {
      if (this.partner) {
        if (this.partner.name) {
          if (this.partner.nameEn) {
            return this.partner.nameEn;
          }
        }
      }
      return;
    },
    countries() {
      return this.$store.getters["entityList"]("countries");
    },
    activeCountries() {
      return this.countries.filter(item => {
        return item.isActive;
      });
    },
    user() {
      return this.$store.getters["user/user"];
    },
    currentEventAran() {
      console.log('currentEventAran - event:', this.event);
      console.log('currentEventAran - event.aran:', this.event && this.event.aran);
      console.log('currentEventAran - all arans in store:', this.$store.state.entities.arans);
      if (this.event && this.event.aran) {
        const aran = this.$store.state.entities.arans[this.event.aran];
        console.log('currentEventAran - found aran:', aran);
        return aran;
      }
      return null;
    },
    aranEvents() {
      console.log('aranEvents - currentEventAran:', this.currentEventAran);
      console.log('aranEvents - event.aran:', this.event && this.event.aran);
      console.log('aranEvents - all events in store:', Object.values(this.$store.state.entities.events));
      if (!this.currentEventAran) {
        console.log('aranEvents - no currentEventAran, returning empty array');
        return [];
      }
      
      // Get all events that have the same ARAN ID
      const events = Object.values(this.$store.state.entities.events).filter(event => {
        console.log('aranEvents - checking event:', event._id, 'event.aran:', event.aran, 'this.event.aran:', this.event.aran);
        return event.aran === this.event.aran;
      }).sort((a, b) => {
        // Sort by start date, newest first
        return new Date(b.startDate) - new Date(a.startDate);
      });
      console.log('aranEvents - found events:', events);
      return events;
    },
    showAllEvents() {
      return this.$store.getters["events/showAllEvents"];
    },
    eventIdsToShow() {
      if (this.showAllEvents && this.currentEventAran) {
        // Return all event IDs that have the same ARAN
        return this.aranEvents.map(event => event._id);
      } else {
        // Return just the current event ID
        return [this.eventId];
      }
    }
  },

  methods: {
    envokeMethodByName(name) {
      this[name]();
    },
    backButtonHandler(isMobile) {
      if (isMobile) {
        this.shouldShowMainMenuAutomatically = false;
      } else {
        this.shouldShowMainMenuAutomatically = true;
      }
      if (this.isFirstPage) {
        this.$router.push("/");
      } else {
        this.$router.go(-1);
      }
    },
    toggleMenuForMobile() {
      this.isMainMenuActive = !this.isMainMenuActive;
      this.mainMenuMiniVariant = false;
    },
    setLayout(layout) {
      this.eventPageLayout = layout;
    },
    showAddEventDialog() {
      this.$store.commit("events/TOGGLE_ADD_EVENT_DIALOG", true);
    },
    showCloseEventDialog() {
      if (this.event && this.event.endDate) {
        this.editEventEndDate();
      } else {
        this.$store.commit("events/TOGGLE_CLOSE_EVENT_DIALOG", true);
      }
    },
    showEventDutiesDialog() {
      this.$store.commit("events/TOGGLE_EVENT_DUTIES_DIALOG", true);
    },
    editEvent() {
      let entity = this.event;
      let isNew = false;
      this.$store.commit("ADD_EDITABLE_ENTITY", {
        entity,
        schema: "eventSchema"
      });
      this.$store.commit("SET_ENTITY_EDIT_DATA", {
        id: entity._id,
        resource: this.$store.state.resources.event,
        isNew
      });
      this.entityEditDialog = true;
    },
    editEventEndDate() {
      let entity = this.event;
      let isNew = false;
      this.$store.commit("ADD_EDITABLE_ENTITY", {
        entity,
        schema: "eventSchema"
      });
      this.$store.commit("SET_ENTITY_EDIT_DATA", {
        id: entity._id,
        resource: this.$store.state.resources.closeEvent,
        isNew
      });
      this.entityEditDialog = true;
    },
    removeEvent() {
      this.$confirm("האם למחוק את האירוע? זהירות! אין אפשרות לשחזר אותו").then(
        res => {
          if (!res) {
            return;
          }

          let eventId = this.$route.params.id;
          if (eventId) {
            this.$store
              .dispatch("CLEAR_CACHE")
              .then(() => {
                // return this.$store.dispatch("partners/REMOVE_PARTNER", eventId);
                return this.$store.dispatch("REMOVE_ENTITY", {
                  url: this.$store.state.resources.event.endpoint,
                  entityType: this.$store.state.resources.event.entityType,
                  id: eventId
                });
              })
              .then(() => {
                this.$store.dispatch("SHOW_SNACKBAR", {
                  text: "האירוע נמחק",
                  color: "success"
                });
              })
              .catch(err => {
                this.$store.dispatch("SHOW_SNACKBAR", {
                  text: err.response ? err.response.data.message : err.message,
                  color: "error"
                });
              })
              .finally(() => {
                this.$router.go(-1);
              });
          }
        }
      );
    },
    navigateToEvent(eventId) {
      console.log('AppBar navigateToEvent - switching to eventId:', eventId);
      
      // Update store to show only the new event
      this.$store.commit('events/SET_EVENT_IDS_TO_SHOW', [eventId]);
      this.$store.commit('events/SET_SHOW_ALL_EVENTS', false);
      
      console.log('AppBar navigateToEvent - store updated, navigating...');
      
      // Navigate to the new event
      this.$router.push(`/events/${eventId}`);
    },
    toggleAllEvents() {
      const currentState = this.$store.getters["events/showAllEvents"];
      const isCyclingMode = this.$store.getters["events/isCyclingMode"];
      
      console.log('AppBar toggleAllEvents - currentState:', currentState, 'isCyclingMode:', isCyclingMode);
      console.log('AppBar toggleAllEvents - currentEventAran:', this.currentEventAran);
      console.log('AppBar toggleAllEvents - aranEvents:', this.aranEvents);
      console.log('AppBar toggleAllEvents - event:', this.event);
      
      if (!currentState && this.aranEvents.length >= 1) {
        // Switching to show ALL events data at once
        console.log('AppBar toggleAllEvents - showing ALL events data');
        console.log('AppBar toggleAllEvents - aranEvents:', this.aranEvents);
        this.$store.commit('events/SET_SHOW_ALL_EVENTS', true);
        this.$store.commit('events/SET_CYCLING_MODE', false);
        
        // Set all ARAN event IDs to show all data
        const allEventIds = this.aranEvents.map(event => event._id);
        console.log('AppBar toggleAllEvents - setting eventIdsToShow to:', allEventIds);
        console.log('AppBar toggleAllEvents - allEventIds type:', typeof allEventIds, 'length:', allEventIds.length);
        this.$store.commit('events/SET_EVENT_IDS_TO_SHOW', allEventIds);
        
        // Force components to refetch data by triggering a global event
        this.$nextTick(() => {
          console.log('AppBar toggleAllEvents - triggering global refetch event');
          this.$bus.$emit('refetch-all-data');
        });
      } else {
        // Switching back to current event only
        console.log('AppBar toggleAllEvents - showing current event only');
        this.$store.commit('events/SET_SHOW_ALL_EVENTS', false);
        this.$store.commit('events/SET_CYCLING_MODE', false);
        
        // Set back to current event
        const currentEventId = this.$route.params.id;
        console.log('AppBar toggleAllEvents - setting back to current eventId:', currentEventId);
        this.$store.commit('events/SET_EVENT_IDS_TO_SHOW', [currentEventId]);
      }
    },

    getCyclingButtonText() {
      const showAllEvents = this.$store.getters["events/showAllEvents"];
      
      if (this.aranEvents.length < 1) {
        return 'כולם';
      } else if (showAllEvents) {
        return 'אירוע נוכחי';
      } else {
        return 'כולם';
      }
    },
    returnToEvents() {
      this.$router.push('/events');
    },
    getEventStatus(event) {
      if (event.endDate) {
        return 'הסתיים';
      } else {
        return 'פעיל';
      }
    },
    testSetEventIds() {
      console.log('testSetEventIds - current event:', this.event);
      console.log('testSetEventIds - aranEvents:', this.aranEvents);
      console.log('testSetEventIds - all events in store:', Object.values(this.$store.state.entities.events));
      
      // Manually set event IDs for testing
      const testEventIds = this.aranEvents.map(event => event._id);
      console.log('testSetEventIds - setting test event IDs:', testEventIds);
      this.$store.commit('events/SET_EVENT_IDS_TO_SHOW', testEventIds);
      this.$store.commit('events/SET_SHOW_ALL_EVENTS', true);
      
      // Trigger refetch
      this.$nextTick(() => {
        this.$bus.$emit('refetch-all-data');
      });
    },
    createPartner() {
      let newEntity = {
        _id: generateId(),
        created: new Date(),
        lastValidation: new Date()
      };
      this.editPartner(newEntity, true);
    },
    editPartner(entity, isNew) {
      this.$store.commit("ADD_EDITABLE_ENTITY", {
        entity,
        schema: "partnerSchema"
      });
      this.$store.commit("SET_ENTITY_EDIT_DATA", {
        id: entity._id,
        resource: this.$store.state.resources.partner,
        isNew
      });
      this.entityEditDialog = true;
    },
    createTranslator() {
      let newEntity = {
        _id: generateId(),
        created: new Date(),
        lastValidation: new Date()
      };
      this.editTranslator(newEntity, true);
    },
    editTranslator(entity, isNew) {
      this.$store.commit("ADD_EDITABLE_ENTITY", {
        entity,
        schema: "translatorSchema"
      });
      this.$store.commit("SET_ENTITY_EDIT_DATA", {
        id: entity._id,
        resource: this.$store.state.resources.translator,
        isNew
      });
      this.entityEditDialog = true;
    },
    removeTranslator() {
      this.$confirm("האם למחוק את המתורגמן?").then(res => {
        if (!res) {
          return;
        }

        let translatorId = this.$route.params.id;
        if (translatorId) {
          this.$store
            .dispatch("CLEAR_CACHE")
            .then(() => {
              return this.$store.dispatch("REMOVE_ENTITY", {
                url: this.$store.state.resources.translator.endpoint,
                entityType: this.$store.state.resources.translator.entityType,
                id: translatorId
              });
            })
            .then(() => {
              this.$store.dispatch("SHOW_SNACKBAR", {
                text: "המתורגמן נמחק",
                color: "success"
              });
              this.$router.push("/translators");
            })
            .catch(err => {
              this.$store.dispatch("SHOW_SNACKBAR", {
                text: err.response ? err.response.data.message : err.message,
                color: "error"
              });
            });
        }
      });
    },
    removePartner() {
      this.$confirm("האם למחוק את הספק?").then(res => {
        if (!res) {
          return;
        }

        let partnerId = this.$route.params.id;
        if (partnerId) {
          this.$store
            .dispatch("CLEAR_CACHE")
            .then(() => {
              // return this.$store.dispatch("partners/REMOVE_PARTNER", partnerId);
              return this.$store.dispatch("REMOVE_ENTITY", {
                url: this.$store.state.resources.partner.endpoint,
                entityType: this.$store.state.resources.partner.entityType,
                id: partnerId
              });
            })
            .then(() => {
              this.$store.dispatch("SHOW_SNACKBAR", {
                text: "הספק נמחק",
                color: "success"
              });
            })
            .catch(err => {
              this.$store.dispatch("SHOW_SNACKBAR", {
                text: err.response ? err.response.data.message : err.message,
                color: "error"
              });
            })
            .finally(() => {
              this.$router.go(-1);
            });
        }
      });
    },
    onCountryChange() {
      setTimeout(() => {
        this.$router.push(
          this.selectedCountry
            ? `/countries/${this.selectedCountry}`
            : `/countries`
        );
      }, 50);
    },
    shouldShow,
    userAvatar(user) {
      if (user) {
        if (user.image) {
          return user.image;
        } else {
          return `https://ui-avatars.com/api/?name=${
            user.name
          }&background=${
            this.userAvatarColor(user)
          }&size=80&color=ffffff&rounded=1&length=1`;
        }
      }
    },
    userAvatarColor(user) {
      if (user) {
        let color = user.color;
        if (color) {
          color = camelCase(color);
        } else {
          color = "blue";
        }
        return colors[color].base.substr(1);
      } else {
        return null;
      }
    },
  },

  components: {
    WorldClock
  },

  watch: {
    "$route.path": function(val) {
      this.isFirstPage = false;
    },
    "event.aran": {
      immediate: true,
      handler(aranId) {
        if (!aranId) {
          return;
        }
        this.$store.dispatch("ARAN_LOAD_CONTEXT", {
          aranId: String(aranId),
          openAllEvents: false
        });
      }
    }
  },

  mounted() {
    // Initialize event IDs to show (default to current event)
    const currentEventId = this.$route.params.id;
    console.log('AppBar mounted - initializing eventIdsToShow with:', currentEventId);
    this.$store.commit('events/SET_EVENT_IDS_TO_SHOW', [currentEventId]);
  },


  // beforeMount() {
  //   this.selectedCountry = this.$route.params.id || null;
  // }
};
</script>

<style scoped>
</style>

<style>
.aran-events-menu {
  max-height: 360px !important;
  overflow-y: auto !important;
}
.aran-events-menu .v-list {
  padding: 0;
}
</style>



// WEBPACK FOOTER //
// src/components/AppBar.vue